import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [loading, setLoading] = useState(true);

  /* -----------------------------
        FETCH USER IF TOKEN EXISTS
  ------------------------------*/
  useEffect(() => {
    const fetchMe = async () => {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const res = await api.get("/auth/me");
        setUser(res.data.user);
      } catch (err) {
        console.error(err);
        setToken(null);
        localStorage.removeItem("token");
      } finally {
        setLoading(false);
      }
    };
    fetchMe();
  }, [token]);

  /* -----------------------------
        LOGIN
  ------------------------------*/
  const login = async (mobile, password) => {
    const res = await api.post("/auth/login", { mobile, password });
    const { token: jwtToken, user: userData } = res.data;

    setToken(jwtToken);
    setUser(userData);
    localStorage.setItem("token", jwtToken);
  };

  /* -----------------------------
        SIGNUP AFTER OTP VERIFY
  ------------------------------*/
  const signup = async (payload) => {
    const res = await api.post("/auth/signup", payload);
    const { token: jwtToken, user: userData } = res.data;

    setToken(jwtToken);
    setUser(userData);
    localStorage.setItem("token", jwtToken);
  };

  /* -----------------------------
        SEND OTP (signup or forgot password)
  ------------------------------*/
  const sendOTP = async (mobile, purpose = "signup") => {
    const res = await api.post("/otp/send-otp", {
      phoneNumber: mobile,
      purpose, // "signup" OR "forgot"
    });
    return res.data; // { success, message }
  };

  /* -----------------------------
        VERIFY OTP
  ------------------------------*/
  const verifyOTP = async (mobile, otp) => {
    const res = await api.post("/otp/verify-otp", {
      phoneNumber: mobile,
      otp,
    });
    return res.data;
  };

  /* -----------------------------
        RESET PASSWORD (AFTER OTP VERIFIED)
  ------------------------------*/
  const resetPassword = async (mobile, newPassword) => {
    const res = await api.post("/auth/reset-password", {
      mobile,
      newPassword,
    });
    return res.data;
  };

  /* -----------------------------
        LOGOUT
  ------------------------------*/
  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        login,
        logout,
        signup,
        sendOTP,
        verifyOTP,
        resetPassword,
        setUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
